<div class="measure-metric-widget">
    <!-- Measure -->
    <nb-select
        outline
        placeholder="Select Measure"
        [selected]="(activeMeasure$ | async)?.key"
        (selectedChange)="onMeasureSelect($event)"
        class="nb-select-in-map"
    >
        <nb-option *ngFor="let measure of measureItems" [value]="measure.key" [disabled]="!measure.enabled">
            {{ getMeasureLabel(measure.key) }}
        </nb-option>
    </nb-select>

    <!-- Metric -->
    <nb-select
        outline
        placeholder="Select Metric"
        [selected]="(activeMetric$ | async)?.key"
        (selectedChange)="onMetricSelect($event)"
    >
        <nb-option *ngFor="let metric of metricItems" [value]="metric?.key" [disabled]="!metric.enabled">
            {{ getMetricLabel(metric?.key) }}
        </nb-option>
    </nb-select>
</div>
